export const SET_ASSERT_LIST = 'SET_ASSERT_LIST'
export const GET_ASSERT_LIST = 'GET_ASSERT_LIST'
export const SET_ASSERT_LIST_LOADING = 'SET_ASSERT_LIST_LOADING'

export const CREATE_TRANSACTION = 'CREATE_TRANSACTION'
export const CREATE_TRANSACTION_LOADING = 'CREATE_TRANSACTION_LOADING'
export const CREATE_TRANSACTION_RESET_FORM = 'CREATE_TRANSACTION_RESET_FORM'

export const SET_SHOW_MOBILE_CREATE_TRANSACTION_MODAL = 'SET_SHOW_MOBILE_CREATE_TRANSACTION_MODAL'
export const SET_SHOW_MOBILE_TRADE_BLOCK_MODAL = 'SET_SHOW_MOBILE_TRADE_BLOCK_MODAL'
export const SET_SHOW_MOBILE_POSITION_MODAL = 'SET_SHOW_MOBILE_POSITION_MODAL'
